import styles from './styles.module.scss';
import CompanyGroup from 'models/Profile/CompanyGroups';
import CompanyComponent from '../company';
import Interface from '../Interface';
import { filter, sortCompanies, sortCompaniesGroup } from '../filters/filter';

type GroupedCompanies = {
  companiesGroup : Array<CompanyGroup>,
  filterConditions: string | undefined
}

const groupedCompanies = (props : GroupedCompanies) : Interface => {
  if(!props.companiesGroup)
    return { companies: [] };


  const getCompanies = () : Array<JSX.Element> => {
    return (
      props
        .companiesGroup
        .sort(sortCompaniesGroup)
        .filter(x => x.companies.some(y => filter(props.filterConditions, y)))
        .map((group, i) => {
          const companies = group
            .companies
            .sort(sortCompanies)
            .filter(x => filter(props.filterConditions, x));

          return (
            <div key={i}>
              {(group.groupName && companies.length > 0) &&
                <div className={styles['biobar-group-name']}>
                  <p>{group.groupName}</p>
                </div>}
              {companies.map((company, i) => <CompanyComponent {...company} hasGroup={group.groupName !== undefined} key={i} />)}
            </div>
          );
        })
    );
  };

  return {
    companies: getCompanies()
  };
};

export default groupedCompanies;